import Vue from 'vue'
import {
storage
} from './common.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import store from '../store/index'
import signParams from "request-sign";

Vue.use(AjaxPlugin)

/**
* 拦截请求
*/


Vue.http.interceptors.request.use(config => {
config.timeout = 1000 * 60

let token = storage.getSessionstorage('token')
token && (config.headers.token = token)


let payloadFieldName = ["post", "put", "patch"].includes(config.method) ? 'data' : 'params'

if (storage.getSessionstorage('openid') != undefined) {
const baseParams = {
uniqueCode: storage.getSessionstorage('openid'),
source: store.state.Env.source.toString()
}
config[payloadFieldName] = {
...baseParams,
...config[payloadFieldName]
}

}
config[payloadFieldName] = {...config[payloadFieldName], ...signParams(config.method, config[payloadFieldName])}
return config
}, error => {
return Promise.reject(error)
})

/**
* 拦截响应
*
*/
Vue.http.interceptors.response.use(response => {


Vue.$vux.loading.hide() 
return response
}, error => {
Vue.$vux.loading.hide()

return Promise.resolve(error.response)
})

/**
* get request
* 除了请求的默认的必要参数外，添加了是否显示loading的属性,默认显示
*/
const get = function (url, params = {}, showLoading = true) {
if (showLoading) {
Vue.$vux.loading.show({
text: '加载中'
})
}
return Vue.http.get(url, {
params
}).catch(err => {
console.log(err)
})
}


const post = function (url, params = {}, showLoading = true) {
if (showLoading) {
Vue.$vux.loading.show({
text: '加载中'
})
}
return Vue.http.post(url, params).catch(err => {
console.log(err)
})
}

export default {
get,
post
}



// WEBPACK FOOTER //
// ./src/js/http.js